const Videos =()=>{
 return(
    <div>
        <h2>Videos</h2>
    </div>
 )
}
export default Videos;